export default __webpack_public_path__ + "static/media/icons8-construction.f796f059.svg";